// extracted by mini-css-extract-plugin
export default {"headerCounterPanelContainer":"UD79-rLQQkU6gomvycj5e","counterValue":"_2CfiLWs6GbLEH_opWAyxoA","counterLabel":"_3L3xOVXHanhu6aAJ0MY0A6"};